import React, { useEffect } from 'react';

// Redux
import { useDispatch } from 'react-redux';

// Material
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';

// Formik
import { useFormik } from 'formik';

// Yup
import { object, number } from 'yup';

// Actions
import * as FacialActions from 'store/ducks/facial/actions';

// Componentes
import { MaskedInputPercent } from 'components';

const ScoreFilter: React.FC = () => {
  const dispatch = useDispatch();

  const SCORE_LIMIT = 100;

  const formik = useFormik({
    initialValues: {
      score: '',
    },
    validationSchema: object().shape({
      score: number(),
    }),
    onSubmit: () => {},
  });

  useEffect(() => {
    dispatch(
      FacialActions.setSelectedScore({
        scorePercent: formik.values.score
          ? parseInt(formik.values.score, 10)
          : '',
      }),
    );
  }, [dispatch, formik.values.score]);

  return (
    <Grid container>
      <TextField
        placeholder='Score - de 0 a 100'
        fullWidth
        label='score'
        InputProps={{
          inputComponent: MaskedInputPercent as any,
        }}
        id='text-field-score'
        margin='normal'
        name='score'
        autoFocus
        onBlur={formik.handleBlur}
        onChange={(e) => {
          const value = e.target.value.replace(/%/g, '');
          if (parseInt(value, 10) > SCORE_LIMIT) {
            formik.setFieldValue('score', '');
            return;
          }
          formik.handleChange(e);
        }}
        value={formik.values.score}
        variant='outlined'
      />
    </Grid>
  );
};

export { ScoreFilter };
export default ScoreFilter;
